module.exports = __webpack_public_path__ + "static/media/team-mosaic-01.310f918f.jpg";